"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactUse = require("react-use");
var _moment = _interopRequireDefault(require("moment"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("../typography");
var _colors = require("../../birch/colors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var birchTheme = {
  timeUsedColor: _colors.FullPalette.EVERGREEN_700,
  timeLeftColor: _colors.FullPalette.EVERGREEN_600
};
var AudioTimer = function AudioTimer(props) {
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    secondsElapsed = _useState2[0],
    setSecondsElapsed = _useState2[1];
  (0, _react.useEffect)(function () {
    if (secondsElapsed >= props.maxSeconds) props.onStop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondsElapsed]);
  (0, _reactUse.useInterval)(function () {
    return setSecondsElapsed(secondsElapsed + 1);
  }, 1000);
  var timeUsed = (0, _moment["default"])(secondsElapsed.toString(), 'ss');
  var timeLeft = (0, _moment["default"])((props.maxSeconds - secondsElapsed).toString(), 'ss');
  return /*#__PURE__*/React.createElement(CounterWrapper, {
    "data-provides": "audio-timer"
  }, "Recording ", timeUsed.format('mm:ss'), /*#__PURE__*/React.createElement(_typography.FieldNotice, null, " / \u2212 ".concat(timeLeft.format('mm:ss'))));
};
AudioTimer.defaultProps = {
  maxSeconds: 10
};
var CounterWrapper = _styledComponents["default"].span.withConfig({
  displayName: "audio_timer__CounterWrapper"
})(["font-size:14px;color:", ";padding:7px 15px;display:inline-block;vertical-align:middle;", "{font-size:14px;color:", ";}"], birchTheme.timeUsedColor, _typography.FieldNotice, birchTheme.timeLeftColor);
var _default = exports["default"] = AudioTimer;